import React, { useState, JSX } from 'react';
import useCms from '../../Hooks/useCms';
import { useMount } from 'react-use';
import './Spinner.scss';
import defaultAjaxLoader from './ajax-loader.svg';

export const Spinner = (props: { defaultSpinner?: boolean }): JSX.Element => {
  const cms = useCms();
  const [ajaxLoader, setAjaxLoader] = useState<string>();

  const cachedItem = sessionStorage.getItem('AJAX-LOADER');

  useMount(async () => {
    if (cachedItem) {
      setAjaxLoader(cachedItem);
    } else if (props.defaultSpinner) {
      setAjaxLoader(defaultAjaxLoader);
    } else {
      cms
        .fetchLoadingImage()
        .then(v => {
          sessionStorage.setItem('AJAX-LOADER', v || defaultAjaxLoader);
          setAjaxLoader(v || defaultAjaxLoader);
        })
        .catch(() => setAjaxLoader(defaultAjaxLoader));
    }
  });

  return <div className="meg_spinner">{ajaxLoader && <img src={ajaxLoader} alt="loader" />}</div>;
};
